module.exports = __webpack_public_path__ + "img/US_InfArmor_ua.33c66f20.webp";